import { Button, Card, Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import noimage from "../../../../assets/Images/no_image_available.jpg";
import { formatNumberWithCommas } from "../../../../constants/constants";
import { OptionMenuEnum } from "../../../../constants/enums/option-menu-enum";
import { useStore } from "../../../../contexts/store-provider";
import {
  IStoreCmsVM,
  ITreatmentWithOptionVM,
} from "../../../../models/response/IStoreCmsResponse";
import ConfirmPopup from "../../../../shared-components/popup/confirm/confirm-popup";
import ConfirmPopupHOC from "../../../../shared-components/popup/confirm/confirm-popup-hoc";
import { formatMessage } from "../../../../translations/format-message";

interface IProps {
  treatment: ITreatmentWithOptionVM;
  store: IStoreCmsVM;
  storeCode: string;
  showConfirmPopup: boolean;
  confirmPopupToggleHandler: () => void;
}

const StoreServiceListSection = (props: any) => {
  const history = useHistory();
  const { bookingManagementStore } = useStore();
  const { setSelectedService, setIsSourceFeatured } =
    bookingManagementStore;

  const handleBooking = (treatmentObj: ITreatmentWithOptionVM) => {
    // You can add any additional logic here before navigating

    if (
      treatmentObj?.OptionMenu == OptionMenuEnum.Mandatory &&
      treatmentObj?.Options?.length > 0
    ) {
      // Here you can handle the booking logic, such as navigating to a booking page
      props.confirmPopupToggleHandler();
      setIsSourceFeatured(true);
      setSelectedService(returnBookingData(treatmentObj));
    } else {
      setIsSourceFeatured(true);
      setSelectedService(returnBookingData(treatmentObj));
      goToBooking();
    }
  };

  const goToBooking = () => {
    history.push(`/store/${props.storeCode}/reservation`);
  };

  const returnBookingData = (treatmentObj: ITreatmentWithOptionVM) => {
    const options = (treatmentObj.Options || [])
      .map((o: any) => o?.OptionId)
      .filter(Boolean); // Remove null/undefined OptionIds

    if (treatmentObj.OptionMenu === OptionMenuEnum.Mandatory) {
      return {
        CategoryId: treatmentObj.CategoryId,
        StoreId: props.store.Id,
        TreatmentId: treatmentObj.TreatmentId,
        OptionIds: [], // Can be [] if no options
      };
    }

    if (treatmentObj.OptionMenu === OptionMenuEnum.NonMandatory) {
      return {
        CategoryId: treatmentObj.CategoryId,
        StoreId: props.store.Id,
        TreatmentId: treatmentObj.TreatmentId,
        OptionIds: [], // Can also be [] if no options selected
      };
    }

    // Fallback in case OptionMenu is some other value
    return {
      CategoryId: treatmentObj.CategoryId,
      StoreId: props.store.Id,
      TreatmentId: treatmentObj.TreatmentId,
      OptionIds: [],
    };
  };

  return (
    <>
      {props.showConfirmPopup && (
        <ConfirmPopup
          modalSubmit={goToBooking}
          modalClosed={() => {
            setSelectedService(undefined);
            props.confirmPopupToggleHandler();
          }}
          isLoading={false}
          title={formatMessage("treatment_info")}
          message={formatMessage("treatment_info_message")}
        />
      )}
      <Col xs={12} sm={12} md={12}>
        <Card className="shadow-sm mb-3">
          <Card.Body className="p-0">
            <Row className="align-items-center g-0">
              {/* Image */}
              <Col xs={5} sm={4} md={3} lg={2} xl={2} xxl={2}>
                <img
                  src={props.treatment.Image || noimage}
                  alt="Store"
                  className="img-fluid store-image"
                />
              </Col>

              {/* Store Details */}
              <Col xs={12} sm={8} md={9} lg={10} xl={10} xxl={10} className="p-3">
                <Row>
                  <Col xs={12} lg={12} xl={9} xxl={10}>
                    <h3 className="text-dark fw-md">
                      {props.treatment.TreatmentName}
                    </h3>
                    <p className="text-muted mb-3 mb-xl-0">
                      {props.treatment.Description }
                    </p>
                  </Col>
                  <Col
                    xs={12}
                    lg={12}
                    xl={3}
                    xxl={2}
                    className="text-start text-xl-end check-availability-wrapper"
                  >
                    <h3 className="text-danger mb-2 mb-xl-3 fw-normal">
                      <i className="bi bi-currency-yen"></i>
                      {formatNumberWithCommas(props.treatment.FeeIncludingTax)}
                    </h3>
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleBooking(props.treatment);
                      }}
                    >
                      <FormattedMessage id="seat_check" />
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default ConfirmPopupHOC(StoreServiceListSection);
